import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import Down from '../../assets/arrowDownNew.svg';
import Right from '../../assets/arrowRightNew.svg';

// Styled components
export const Container = styled(Box)(
  ({ theme }) => `
    padding: ${theme.header.height} 0 2rem 0; 
    min-height: 100vh; 
    background: #f8f8f8;
  `
);

const Card = styled.div`
  width: 90%;
  max-width: 615px;
  min-height: 80vh;
  margin: 6rem auto 0;
  position: relative;

  @media (max-width: 480px) {
    width: 95%;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    width: 90%;
    max-width: 615px;
  }

  @media (min-width: 769px) {
    width: 100%;
    max-width: 700px;
  }
`;

const InnerCard = styled.div`
  background: white;
  padding: clamp(0.1rem, 2vw, 2rem);
  border-radius: 16px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 
              0px 2px 6px 2px rgba(0, 0, 0, 0.15);
`;

const TabContainer = styled.div`
  display: flex;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  max-width: 600px;
  margin: 0 auto 2rem auto;
  
`;

const Tab = styled.button`
  flex: 1;
  padding: 12px 16px;
  background: ${props => props.active ? '#0040BF' : '#f4f4f4'};
  color: ${props => props.active ? '#fff' : '#91908a'};
  border: none;
  cursor: pointer;
  font-size: clamp(0.75rem, 1.5vw, 1rem);
  font-weight: 500;
  transition: all 0.3s ease;
  


  &:hover {
    background: ${props => props.active ? '#0040BF' : '#f4f4f4'};
  }

  .tab-subtitle {
    font-size: 0.7rem;
    opacity: 0.8;
    margin-top: 2px;
  }
`;

const Title = styled.h1`
  text-align: center;
  font-size: clamp(1.8rem, 3vw, 3.2rem);
  font-weight: 600;
  color: #2E2C21;
  margin: 2rem 0;
`;

const AccordionItem = styled.div`
  border: 1px solid #B1B1B1;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 16px;
`;

const AccordionHeader = styled.button`
  width: 100%;
  padding: 16px 24px;
  text-align: left;
  background: white;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #2E2C21;
  transition: background-color 0.3s ease;
  font-size: clamp(0.9rem, 2vw, 1rem);

  &:hover {
    background: #f9f9f9;
  }
`;

const AccordionContent = styled.div`
  padding: 0 24px 24px 24px;
`;

const StepList = styled.ol`
  margin-top: 16px;
`;

const StepItem = styled.li`
  display: flex;
  margin-bottom: 12px;
  font-size: 0.9rem;
  color: #666;

  .step-number {
    font-weight: 400;
    color: #2E2C21;
    margin-right: 8px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
`;

const GuideButton = styled.button`
  background: #f9f5de;
  color: #0040BF;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  border: 0.4px solid #0040BF;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background: #f0ebcc;
  }
`;

const WatchButton = styled.button`
  background: #0040BF;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background: #003399;
  }
`;

const ContactButton = styled.button`
  background: #374DA0;
  color: white;
  padding: 20px 32px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  margin: 2rem auto;
  display: block;
  transition: background-color 0.3s ease;

  &:hover {
    background: #2a3a80;
  }
`;

// Guides array
const guides = [
  {
    key: "signup",
    title: "How to Sign Up on Parrotica",
    steps: [
      "Visit the website at www.parrotica.com",
      "Click on 'Create an Account' at the top right corner",
      "Fill in your details: name, email, and password",
      "Click 'Next' to verify your account",
      "A confirmation email with an OTP will be sent to you",
      "Log in with your registered email and password"
    ],
    buttonText: "Sign Up",
    link: "/signup",
    videoLink: "https://www.youtube.com/watch?v=QVfIEhB50w4](https://www.youtube.com/watch?v=QVfIEhB50w4)"
  },
  {
    key: "wallet",
    title: "How to Top Up Your Wallet",
    steps: [
      "Log in to your Parrotica account",
      "Click the 'Top Up' button on the navigation bar",
      "Enter the amount you want to fund your account with",
      "Click 'Confirm' to continue the process",
      "Choose a payment method (bank transfer or online payment)",
      "Follow the payment instructions",
      "Once payment is confirmed, your wallet will be credited automatically"
    ],
    buttonText: "Top-up my wallet",
    link: "/top-up",
    videoLink: "https://www.youtube.com/watch?v=kI7tQ0fhhHw](https://www.youtube.com/watch?v=kI7tQ0fhhHw)"
  },
  {
    key: "senderId",
    title: "How to Apply for a Sender ID",
    steps: [
      "Log in to your Parrotica account",
      "Click 'Send Message' on the navigation bar",
      "Click 'Apply for Sender ID'",
      "Follow the Sender ID guidelines",
      "Fill in required details (max 11 characters, no special characters)",
      "Click 'Apply'",
      "You'll receive a notification email immediately",
      "Wait for approval (24–72 hours)"
    ],
    buttonText: "Apply for Sender ID",
    link: "/send-message/verify",
    videoLink: "https://www.youtube.com/watch?v=KHM8E-Z4Oyc](https://www.youtube.com/watch?v=KHM8E-Z4Oyc)" 
  },
  {
    key: "sendMessage",
    title: "How to Send a Message",
    steps: [
      "Click on 'Send Message' from the dashboard",
      "Choose your Sender ID",
      "Select recipients (groups, contacts, or paste option)",
      "Compose your message",
      "Review and click 'Send Message'",
      "Check delivery status in 'Message History'"
    ],
    buttonText: "Send a Message",
    link: "/send-message",
    videoLink: "https://www.youtube.com/watch?v=Ew4mipz2Znc](https://www.youtube.com/watch?v=Ew4mipz2Znc)" 
  },
  {
    key: "transfer",
    title: "How to Transfer SMS Units",
    steps: [
      "Go to 'Transfer SMS Units'",
      "Enter recipient's email and number of units",
      "Confirm and click 'Transfer'",
      "A confirmation will appear once successful"
    ],
    buttonText: "Transfer Units",
    link: "/dashboard",
    videoLink: "https://www.youtube.com/watch?v=w1LAZAEopRE" 
  },
  {
    key: "contacts",
    title: "How to Import / Add Contacts",
    steps: [
      "a. Using Paste Option → Go to 'Contacts' → 'Add Contacts' → Paste numbers",
      "b. Using Create Option → Manually input names & numbers",
      "c. Import CSV File → Use Parrotica template & upload",
      "d. Import VCF File → Upload and validate"
    ],
    buttonText: "Manage Contacts",
    link: "/contacts",
    videoLink: "https://www.youtube.com/watch?v=JoeglRq5hu8](https://www.youtube.com/watch?v=JoeglRq5hu8)"
  },
  {
    key: "schedule",
    title: "How to Schedule a Message",
    steps: [
      "Go to 'Send Message'",
      "Click 'Schedule Message'",
      "Compose message, select Sender ID & contacts",
      "Choose date & time",
      "Confirm by clicking 'Schedule'"
    ],
    buttonText: "Schedule Message",
    link: "/send-message/schedule",
    videoLink: "https://www.youtube.com/watch?v=4nwQY6wQxyo](https://www.youtube.com/watch?v=4nwQY6wQxyo)"
  }
];

const GuideCenter = () => {
  const [activeTab, setActiveTab] = useState('setup');
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleContactNavigation = () => {
    window.location.href = '/dashboard/contact';
  };

  const renderSetupGuide = () => (
    <div>
      {guides.map(guide => (
        <AccordionItem key={guide.key}>
          <AccordionHeader onClick={() => toggleSection(guide.key)}>
            <span>{guide.title}</span>
            <span>{expandedSection === guide.key ? <img src={Down} /> : <img src={Right} />}</span>
          </AccordionHeader>

          {expandedSection === guide.key && (
            <AccordionContent>
              <StepList>
                {guide.steps.map((step, idx) => (
                  <StepItem key={idx}>
                    <span className="step-number">{idx + 1}.</span>
                    <span>{step}</span>
                  </StepItem>
                ))}
              </StepList>

              <ButtonContainer>
                <GuideButton onClick={() => window.location.href = guide.link}>
                  {guide.buttonText}
                </GuideButton>
                <WatchButton onClick={() => window.open(guide.videoLink, '_blank')}>
                  Watch Here
                </WatchButton>
              </ButtonContainer>
            </AccordionContent>
          )}
        </AccordionItem>
      ))}
    </div>
  );

  const renderWhatsNew = () => (
    <div style={{ textAlign: 'center', padding: '48px 0' }}>
      <div style={{ color: '#999', marginBottom: '16px' }}>
        <svg style={{ width: '64px', height: '64px', margin: '0 auto' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 style={{ fontSize: '1.125rem', fontWeight: '500', color: '#333', marginBottom: '8px' }}>Stay Updated</h3>
      <p style={{ color: '#666' }}>Check back here for the latest tools and features.</p>
    </div>
  );

  const renderGetHelp = () => (
    <div style={{ textAlign: 'center', padding: '48px 0' }}>
      <div style={{ color: '#374DA0', marginBottom: '24px' }}>
        <svg style={{ width: '64px', height: '64px', margin: '0 auto' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      </div>
      <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#2E2C21', marginBottom: '16px' }}>Need Help?</h3>
      <p style={{ color: '#666', marginBottom: '32px', fontSize: '1rem' }}>
        We're here to help! Contact our support team for assistance with your account, technical issues, or any questions you may have.
      </p>
      <ContactButton>
        Contact Support
      </ContactButton>
    </div>
  );

  return (
    <Container>
      <Card>
        <InnerCard>
          <Title className='font-cormorant'>Guide Center</Title>
          
          <TabContainer>
            <Tab 
              active={activeTab === 'setup'}
              onClick={() => setActiveTab('setup')}
            >
              Setup Guide
              <div className="tab-subtitle">(Start here if you're new)</div>
            </Tab>
            <Tab 
              active={activeTab === 'whats-new'}
              onClick={() => setActiveTab('whats-new')}
            >
              What's New
              <div className="tab-subtitle">(Stay updated with the latest tools)</div>
            </Tab>
            <Tab 
              active={activeTab === 'get-help'}
              onClick={handleContactNavigation}
            >
              Get Help
              <div className="tab-subtitle">(Contact our support team)</div>
            </Tab>
          </TabContainer>

          <div style={{ position: 'relative' }}>
            {activeTab === 'setup' && renderSetupGuide()}
            {activeTab === 'whats-new' && renderWhatsNew()}
            {activeTab === 'get-help' && renderGetHelp()}
          </div>
        </InnerCard>
      </Card>
    </Container>
  );
};

export default GuideCenter;